var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{attrs:{"id":"nav"}},[_c('Nav')],1),_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col'),_c('v-col',{attrs:{"cols":"10"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.code)}})]),_c('v-col')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }